import React from 'react';

import ControlledInput from './controlledInput'

class Editable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            folded:props.value,
            value:props.value
        }
    }

    onChange() {
        this.setState({folded:true})
        this.props.onSubmit(this.state.value)
    }

    onCancel() {
        this.setState({folded:true,value:this.props.value})
    }

    unfold() {
        this.setState({folded:false})
    }

    render() {
        return this.state.folded ? 
            <div className="editable" onClick={this.unfold.bind(this)}>
                <span>{this.props.value}</span>
                <img src='img/pencil-line.png'/>
            </div> :
            <div className='editable'>
                <ControlledInput type='text' property='value' container={this} onSubmit={this.onChange.bind(this)}/>
                <img src='img/check-line.png' onClick={this.onChange.bind(this)}/>
                <img src='img/close-line.png' onClick={this.onCancel.bind(this)}/>
            </div>
    }
}

export default Editable;
